(function (module) {
    'use strict';

    function LogoutConfig ($stateProvider) {

        $stateProvider
            .state('logout', {
                url: '/logout',
                views: {
                    'main@': {
                        controller: 'LogoutCtrl',
                        template: 'logout'
                    }
                }
            });
    }

    function LogoutCtrl (User, Store, $state) {
        Store.setCurrentSubAccountId(null);

        User
            .logout()
            .$promise
            .then(() => {
                $state.go('login');
            })
            .catch(() => {
                $state.go('login');
            });
    }

    module
        .config(LogoutConfig)
        .controller('LogoutCtrl', LogoutCtrl);

})(angular.module('rocket.components'));
